import {Component, Input, OnInit} from '@angular/core';
import {FaceApiService} from '../../../../services/face-api/face-api.service';

@Component({
  selector: 'app-face-api-config',
  templateUrl: './face-api-config.component.html',
  styleUrls: ['./face-api-config.component.scss']
})
export class FaceApiConfigComponent implements OnInit {
  @Input() showBoxes = true;
  constructor(public faceApiService: FaceApiService) {
  }

  ngOnInit(): void {
  }

}
